import {ApiV0} from '../../api.v0';
import {RestApiService} from '../../../rest-api.service';
import {
    InvoiceCreateReq,
    InvoiceDetailRes,
    InvoiceSendReq,
    InvoiceUpdateReq
} from '../../../../contracts/v0/cp/invoice.contract';
import {Observable} from 'rxjs';

export class ApiV0Invoice {
    segment = '/invoice'

    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + this.segment
    }

    add(req: InvoiceCreateReq): Observable<InvoiceDetailRes> {
        return this.rest.post<InvoiceCreateReq, InvoiceDetailRes>(`${this.segment}`, InvoiceDetailRes, req);
    }

    send(id: number, req: InvoiceSendReq): Observable<InvoiceDetailRes> {
        return this.rest.post<InvoiceSendReq, InvoiceDetailRes>(`${this.segment}/${id}/Send`, InvoiceDetailRes, req);
    }

    update(id: number, req: InvoiceUpdateReq): Observable<InvoiceDetailRes> {
        return this.rest.patch<InvoiceUpdateReq, InvoiceDetailRes>(`${this.segment}/${id}`, InvoiceDetailRes, req);
    }



}